import { Shop } from "../../types/Shop";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

export const updateShop = async (shop: Shop): Promise<void> => {
  if (!shop.id) {
    throw new Error("Community ID is required to update shop");
  }

  const shopRef = firestore
    .collection(DB_PATH.COMMUNITY)
    .doc(shop.id)
    .collection("Shop")
    .doc("shop");

  // Remove the id from the payload since we're storing it at the document level
  const { id, ...payload } = shop;

  // Rethrow. A rejected write here is almost always a rules denial, and
  // swallowing it made the coach's edit vanish with a success message.
  try {
    await shopRef.set(payload, { merge: true });
  } catch (error) {
    console.error("Error updating shop", error);
    throw error;
  }
};
